
import { Component, Vue, Prop } from "vue-property-decorator";
import SkeletonCard from "../SkeletonCard/index.vue";

@Component({
  components: {
    SkeletonCard,
  },
})
export default class CardContainer extends Vue {
  @Prop({ default: "" }) src!: string; // 图标 require('@/assets/images/shouyin/workbench/OverviewData.svg')
  @Prop({ default: "" }) title!: string; // 标题
  @Prop({ default: "" }) desc?: string; // 描述
  @Prop({ default: false }) showRight?: string; // 是否显示右边箭头
  @Prop({ default: () => ({}) }) wrapStyle?: any; // wrap自定义样式  marginBottom: '10px'
  @Prop({ default: "" }) detailPath?: string; // 卡片详情跳转地址
  @Prop({ default: true }) isInit!: boolean; // 数据是否初始化完成

  toDetail() {
    if (!this.detailPath || !this.showRight) return;

    this.$router.push(`${this.detailPath}?isWorkbench=1`);
  }
}
